import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'html-template',
  name: 'HTML Template',
  category: 'files',
  description: 'Format data into HTML using templates. Use with HTML to PDF node to generate PDFs.',
  icon: 'LayoutTemplate',
  iconType: 'lucide',
  color: 'purple',
  version: '1.0.0',

  group: ['transform'],

  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],

  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],

  subtitle: '={{ $parameter.starterTemplate || "custom" }}',

  tags: ['html', 'template', 'format', 'report', 'invoice', 'document'],
};

export default definition;
